import { type FormEvent, useState } from 'react';
import { useMoonbase } from '../lib/moonbase';
import { Icon } from './Icon';

export function NewsletterForm({ compact = false }: { compact?: boolean }) {
  const [email, setEmail] = useState('');
  const { subscribe, configured, openSetup } = useMoonbase();

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!configured) {
      openSetup();
      return;
    }
    subscribe(email.trim() || undefined);
  };

  return (
    <form className={compact ? 'newsletter newsletter--compact' : 'newsletter'} onSubmit={submit}>
      {!compact && (
        <div className="newsletter__copy">
          <span className="eyebrow">Release notes, not noise</span>
          <h2>New tools, updates and useful listening notes.</h2>
          <p>A quiet email when something worth opening is ready.</p>
        </div>
      )}
      <div className="newsletter__form">
        <label className="sr-only" htmlFor={compact ? 'footer-newsletter' : 'newsletter-email'}>Email address</label>
        <input
          id={compact ? 'footer-newsletter' : 'newsletter-email'}
          type="email"
          autoComplete="email"
          placeholder="you@studio.com"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          required
        />
        <button type="submit" aria-label="Subscribe to the newsletter">
          <span>{compact ? 'Join' : 'Keep me posted'}</span>
          <Icon name="arrow" />
        </button>
      </div>
    </form>
  );
}
